import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const userDetailsAtom = atomWithStorage<{
  userId?: string;
  companyName?: string;
  contactPerson?: string;
  email?: string;
  isAdmin?: boolean;
}>(
  "reEquipUserSession",
  {},
  createJSONStorage(() => sessionStorage),
);
